export enum SnackbarNames {
  CONNECTED = 'connected',
  REBOOTING = 'rebooting',
  CONNECTION_FAILED = 'connectionFailed',
  FAVORITE_ADDED = 'favoriteAdded',
  FAVORITE_REMOVED = 'favoriteRemoved',
  FAVORITES_LIMIT = 'favoritesLimit',
}
